import React, { useState } from 'react';
import { SearchProps } from '../types';
import { useTranslation } from '../context/TranslationContext';
import '../styles/Search.css';

const Search: React.FC<SearchProps> = ({ onSearch, placeholder }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setQuery(value);
    onSearch(value);
  };

  return (
    <div className="search-container">
      <div className="search-input-wrapper">
        <svg className="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <input
          type="text"
          id="search-input"
          name="search"
          className="search-input"
          placeholder={placeholder || t('common.search')}
          value={query}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default Search; 